module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="filter_item_clear" data_type="' +
((__t = ( type )) == null ? '' : __t) +
'"></div>\n<div class="filter_item_word filter_text">' +
((__t = ( getValue() )) == null ? '' : __t) +
'</div>';

}
return __p
}